import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "ss-tela-estrutura" }
const _hoisted_2 = { class: "ant-row" }
const _hoisted_3 = { class: "ant-col ant-col-xs-24 ant-col-xl-24" }
const _hoisted_4 = { class: "ant-row" }
const _hoisted_5 = { class: "ant-col ant-col-xs-24 ant-col-xl-19" }
const _hoisted_6 = { class: "ss-tela-titulo" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("h1", null, "Controle de Assinaturas", -1)
const _hoisted_8 = { class: "atalhos" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("span", null, "Remover dos Meus Atalhos", -1)
const _hoisted_10 = {
  style: {"color":"orange","font-size":"20px"},
  class: "anticon"
}
const _hoisted_11 = /*#__PURE__*/_createElementVNode("span", null, "Adicionar aos Meus Atalhos", -1)
const _hoisted_12 = { class: "anticon" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("div", {
  class: "ant-col ant-col-xs-24 ant-col-xl-5",
  style: {"padding-top":"4px"}
}, [
  /*#__PURE__*/_createElementVNode("div", { class: "ant-btn-group ss-tamanho-completo" })
], -1)
const _hoisted_14 = { class: "ss-tela-conteudo" }
const _hoisted_15 = { class: "ss-card ss-card-space" }
const _hoisted_16 = { class: "ant-row" }
const _hoisted_17 = { class: "ant-col ant-col-xs-24 ant-col-xl-4" }
const _hoisted_18 = { class: "ant-col ant-col-xs-24 ant-col-xl-4" }
const _hoisted_19 = { class: "ant-col ant-col-xs-24 ant-col-xl-4" }
const _hoisted_20 = { class: "ant-col ant-col-xs-24 ant-col-xl-4" }
const _hoisted_21 = { class: "ant-col ant-col-xs-24 ant-col-xl-4" }
const _hoisted_22 = { class: "ant-col ant-col-xs-24 ant-col-xl-4" }
const _hoisted_23 = { class: "ss-card ss-card-space ss-alinhar-texto-esquerda" }
const _hoisted_24 = { class: "ant-row" }
const _hoisted_25 = { class: "ant-col ant-col-xs-24 ant-col-xl-8" }
const _hoisted_26 = { class: "ant-col ant-col-xs-24 ant-col-xl-6" }
const _hoisted_27 = { class: "ant-col ant-col-xs-24 ant-col-xl-3" }
const _hoisted_28 = { class: "ant-col ant-col-xs-24 ant-col-xl-4" }
const _hoisted_29 = { class: "ant-col ant-col-xs-24 ant-col-xl-3" }
const _hoisted_30 = ["onClick"]
const _hoisted_31 = { key: 2 }
const _hoisted_32 = { key: 3 }
const _hoisted_33 = {
  key: 4,
  class: "ss-table-apresentacao-mobile"
}
const _hoisted_34 = /*#__PURE__*/_createElementVNode("b", null, "T.DOC:", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_icone = _resolveComponent("icone")!
  const _component_a_tooltip = _resolveComponent("a-tooltip")!
  const _component_totalizador_decorado = _resolveComponent("totalizador-decorado")!
  const _component_selecionar_contratante = _resolveComponent("selecionar-contratante")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_selecionar_plano_assinatura = _resolveComponent("selecionar-plano-assinatura")!
  const _component_selecionar_data = _resolveComponent("selecionar-data")!
  const _component_selecionar_status_assinatura = _resolveComponent("selecionar-status-assinatura")!
  const _component_card = _resolveComponent("card")!
  const _component_a_tag = _resolveComponent("a-tag")!
  const _component_mensagem_sem_dados = _resolveComponent("mensagem-sem-dados")!
  const _component_a_table = _resolveComponent("a-table")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_controle_assinatura_modal = _resolveComponent("controle-assinatura-modal")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _hoisted_7,
              _createElementVNode("div", _hoisted_8, [
                (_ctx.storeSistema.getters.atalhoAdicionado(_ctx.telaBase.identificadorRecurso, _ctx.telaBase.empresasSelecionadas))
                  ? (_openBlock(), _createBlock(_component_a_tooltip, {
                      key: 0,
                      placement: "bottom"
                    }, {
                      title: _withCtx(() => [
                        _hoisted_9
                      ]),
                      default: _withCtx(() => [
                        _createElementVNode("a", {
                          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.removerAtalho(_ctx.telaBase.identificadorRecurso, _ctx.telaBase.empresasSelecionadas)))
                        }, [
                          _createElementVNode("i", _hoisted_10, [
                            _createVNode(_component_icone, { nome: "estrela" })
                          ])
                        ])
                      ]),
                      _: 1
                    }))
                  : (_openBlock(), _createBlock(_component_a_tooltip, {
                      key: 1,
                      placement: "bottom"
                    }, {
                      title: _withCtx(() => [
                        _hoisted_11
                      ]),
                      default: _withCtx(() => [
                        _createElementVNode("a", {
                          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.adicionarAtalho(_ctx.telaBase.identificadorRecurso, _ctx.telaBase.empresasSelecionadas)))
                        }, [
                          _createElementVNode("i", _hoisted_12, [
                            _createVNode(_component_icone, { nome: "favorito" })
                          ])
                        ])
                      ]),
                      _: 1
                    }))
              ])
            ])
          ]),
          _hoisted_13
        ]),
        _createElementVNode("div", _hoisted_14, [
          _createVNode(_component_a_form, { layout: "vertical" }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_15, [
                _createElementVNode("div", _hoisted_16, [
                  _createElementVNode("div", _hoisted_17, [
                    _createVNode(_component_a_tooltip, {
                      placement: "top",
                      title: "Visualizar todas Assinaturas - Não Implantadas"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_totalizador_decorado, {
                          class: "ss-totalizador-decorado",
                          titulo: "NÃO IMPLANTADAS",
                          cor: "#607d8b",
                          iconeColorido: true,
                          iconePequeno: true,
                          valor: _ctx.obtemValoResumo(_ctx.EStatusAssinatura.NaoImplantada),
                          onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.buscarAssinaturasPorStatus(_ctx.EStatusAssinatura.NaoImplantada)))
                        }, null, 8, ["valor"])
                      ]),
                      _: 1
                    })
                  ]),
                  _createElementVNode("div", _hoisted_18, [
                    _createVNode(_component_a_tooltip, {
                      placement: "top",
                      title: "Visualizar todas Assinaturas - Em Teste"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_totalizador_decorado, {
                          class: "ss-totalizador-decorado",
                          titulo: "EM TESTE",
                          cor: "#03a9f4",
                          iconeColorido: true,
                          iconePequeno: true,
                          valor: _ctx.obtemValoResumo(_ctx.EStatusAssinatura.Teste),
                          onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.buscarAssinaturasPorStatus(_ctx.EStatusAssinatura.Teste)))
                        }, null, 8, ["valor"])
                      ]),
                      _: 1
                    })
                  ]),
                  _createElementVNode("div", _hoisted_19, [
                    _createVNode(_component_a_tooltip, {
                      placement: "top",
                      title: "Visualizar todas Assinaturas - Ativas"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_totalizador_decorado, {
                          class: "ss-totalizador-decorado",
                          titulo: "ATIVAS",
                          cor: "#87e22d",
                          iconeColorido: true,
                          iconePequeno: true,
                          valor: _ctx.obtemValoResumo(_ctx.EStatusAssinatura.Ativa),
                          onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.buscarAssinaturasPorStatus(_ctx.EStatusAssinatura.Ativa)))
                        }, null, 8, ["valor"])
                      ]),
                      _: 1
                    })
                  ]),
                  _createElementVNode("div", _hoisted_20, [
                    _createVNode(_component_a_tooltip, {
                      placement: "top",
                      title: "Visualizar todas Assinaturas - Vencidas"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_totalizador_decorado, {
                          class: "ss-totalizador-decorado",
                          titulo: "VENCIDAS",
                          cor: "#ffeb3b",
                          iconeColorido: true,
                          iconePequeno: true,
                          valor: _ctx.obtemValoResumo(_ctx.EStatusAssinatura.Vencida),
                          onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.buscarAssinaturasPorStatus(_ctx.EStatusAssinatura.Vencida)))
                        }, null, 8, ["valor"])
                      ]),
                      _: 1
                    })
                  ]),
                  _createElementVNode("div", _hoisted_21, [
                    _createVNode(_component_a_tooltip, {
                      placement: "top",
                      title: "Visualizar todas Assinaturas - Suspensas"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_totalizador_decorado, {
                          class: "ss-totalizador-decorado",
                          titulo: "SUSPENSAS",
                          cor: "#ff9800",
                          iconeColorido: true,
                          iconePequeno: true,
                          valor: _ctx.obtemValoResumo(_ctx.EStatusAssinatura.Suspensa),
                          onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.buscarAssinaturasPorStatus(_ctx.EStatusAssinatura.Suspensa)))
                        }, null, 8, ["valor"])
                      ]),
                      _: 1
                    })
                  ]),
                  _createElementVNode("div", _hoisted_22, [
                    _createVNode(_component_a_tooltip, {
                      placement: "top",
                      title: "Visualizar todas Assinaturas - Canceladas"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_totalizador_decorado, {
                          class: "ss-totalizador-decorado",
                          titulo: "CANCELADAS",
                          cor: "#f44336",
                          iconeColorido: true,
                          iconePequeno: true,
                          valor: _ctx.obtemValoResumo(_ctx.EStatusAssinatura.Cancelada),
                          onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.buscarAssinaturasPorStatus(_ctx.EStatusAssinatura.Cancelada)))
                        }, null, 8, ["valor"])
                      ]),
                      _: 1
                    })
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_23, [
                _createVNode(_component_card, { titulo: "FILTROS" }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_24, [
                      _createElementVNode("div", _hoisted_25, [
                        _createVNode(_component_a_form_item, {
                          label: "Contratante",
                          class: "ss-margin-campos"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_selecionar_contratante, {
                              codigoSelecionado: _ctx.state.filtros.codigoContratante,
                              "onUpdate:codigoSelecionado": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.state.filtros.codigoContratante) = $event)),
                              apresentarCpfCnpj: true
                            }, null, 8, ["codigoSelecionado"])
                          ]),
                          _: 1
                        })
                      ]),
                      _createElementVNode("div", _hoisted_26, [
                        _createVNode(_component_a_form_item, {
                          label: "Plano",
                          class: "ss-margin-campos"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_selecionar_plano_assinatura, {
                              codigoSelecionado: _ctx.state.filtros.codigoPlano,
                              "onUpdate:codigoSelecionado": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.state.filtros.codigoPlano) = $event))
                            }, null, 8, ["codigoSelecionado"])
                          ]),
                          _: 1
                        })
                      ]),
                      _createElementVNode("div", _hoisted_27, [
                        _createVNode(_component_a_form_item, { label: "Data vencimento" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_selecionar_data, {
                              dataSelecionada: _ctx.state.filtros.dataVencimento,
                              "onUpdate:dataSelecionada": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.state.filtros.dataVencimento) = $event))
                            }, null, 8, ["dataSelecionada"])
                          ]),
                          _: 1
                        })
                      ]),
                      _createElementVNode("div", _hoisted_28, [
                        _createVNode(_component_a_form_item, {
                          label: "Status",
                          class: "ss-margin-campos"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_selecionar_status_assinatura, {
                              valor: _ctx.state.filtros.status,
                              "onUpdate:valor": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.state.filtros.status) = $event))
                            }, null, 8, ["valor"])
                          ]),
                          _: 1
                        })
                      ]),
                      _createElementVNode("div", _hoisted_29, [
                        _createVNode(_component_a_form_item, {
                          label: " ",
                          class: "ss-margin-campos"
                        }, {
                          default: _withCtx(() => [
                            _createElementVNode("button", {
                              class: "ant-btn ant-btn-primary ss-tamanho-completo",
                              onClick: _cache[12] || (_cache[12] = ($event: any) => (_ctx.buscarAssinaturas())),
                              title: "Buscar"
                            }, "Buscar")
                          ]),
                          _: 1
                        })
                      ])
                    ])
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_table, {
                  columns: _ctx.gradeBase.colunas.filter(item => item.visible),
                  "data-source": _ctx.state.assinaturas,
                  rowKey: "codigo",
                  pagination: false,
                  loading: _ctx.telaBase.carregando,
                  size: "small"
                }, {
                  bodyCell: _withCtx(({ column, record,text }) => [
                    (column.key === 'Codigo')
                      ? (_openBlock(), _createElementBlock("a", {
                          key: 0,
                          onClick: ($event: any) => (_ctx.visualizarAssinatura(record.codigo))
                        }, "N. " + _toDisplayString(text), 9, _hoisted_30))
                      : (column.key === 'Status')
                        ? (_openBlock(), _createBlock(_component_a_tag, {
                            key: 1,
                            style: {"vertical-align":"middle","height":"15px","border-radius":"45px"},
                            color: _ctx.obterCorStatus(record.status)
                          }, null, 8, ["color"]))
                        : (column.customRenderRow === _ctx.ECustomRenderRow.MascararData)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_31, _toDisplayString(_ctx.UtilitarioData.aplicaFormatoData(text)), 1))
                          : (column.key === 'Recorrencia')
                            ? (_openBlock(), _createElementBlock("span", _hoisted_32, _toDisplayString(_ctx.obterDescricaoRecorrencia(record.recorrencia)), 1))
                            : (column.key === 'Assinatura')
                              ? (_openBlock(), _createElementBlock("div", _hoisted_33, [
                                  _createElementVNode("span", null, [
                                    _hoisted_34,
                                    _createTextVNode(" " + _toDisplayString(record.siglaTipoDocumentoFinanceiro + ' - ' + record.descricaoTipoDocumentoFinanceiro), 1)
                                  ])
                                ]))
                              : _createCommentVNode("", true)
                  ]),
                  emptyText: _withCtx(() => [
                    (_ctx.state.assinaturas.length <= 0)
                      ? (_openBlock(), _createBlock(_component_mensagem_sem_dados, {
                          key: 0,
                          mensagem: "Nenhuma assinatura encontrada"
                        }))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                }, 8, ["columns", "data-source", "loading"])
              ])
            ]),
            _: 1
          }),
          _createVNode(_component_controle_assinatura_modal, {
            visivel: _ctx.state.apresentarModal,
            "onUpdate:visivel": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.state.apresentarModal) = $event)),
            codigo: _ctx.state.codigoAssinatura,
            onAtualizarAssinaturas: _cache[14] || (_cache[14] = ($event: any) => (_ctx.atualizarAssinaturas()))
          }, null, 8, ["visivel", "codigo"])
        ])
      ])
    ])
  ]))
}